"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'chihuahua',
    client_id: '07-tendermint-54',
    connection_id: 'connection-30'
  },
  chain_2: {
    chain_name: 'juno',
    client_id: '07-tendermint-79',
    connection_id: 'connection-46'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-11',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-28',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'chihuahua',
    client_id: '07-tendermint-126',
    connection_id: 'connection-81'
  },
  chain_2: {
    chain_name: 'migaloo',
    client_id: '07-tendermint-21',
    connection_id: 'connection-21'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-39',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'chihuahua',
    client_id: '07-tendermint-191',
    connection_id: 'connection-127'
  },
  chain_2: {
    chain_name: 'neutron',
    client_id: '07-tendermint-74',
    connection_id: 'connection-53'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-76',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-51',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }, {
    chain_1: {
      channel_id: 'channel-77',
      port_id: 'wasm.chihuahua1jwkag4yvhyj9fuddtkygvavya8hmdjuzmgxwg9vp3lw9twv6lrcq9mgl52'
    },
    chain_2: {
      channel_id: 'channel-52',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'chihuahua',
    client_id: '07-tendermint-85',
    connection_id: 'connection-54'
  },
  chain_2: {
    chain_name: 'okexchain',
    client_id: '07-tendermint-5',
    connection_id: 'connection-6'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-24',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'chihuahua',
    client_id: '07-tendermint-45',
    connection_id: 'connection-25'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1666',
    connection_id: 'connection-1278'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-7',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-113',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }, {
    chain_1: {
      channel_id: 'channel-73',
      port_id: 'wasm.chihuahua1jwkag4yvhyj9fuddtkygvavya8hmdjuzmgxwg9vp3lw9twv6lrcq9mgl52'
    },
    chain_2: {
      channel_id: 'channel-11348',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'chihuahua',
    client_id: '07-tendermint-70',
    connection_id: 'connection-38'
  },
  chain_2: {
    chain_name: 'secretnetwork',
    client_id: '07-tendermint-27',
    connection_id: 'connection-13'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-16',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-11',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      properties: 'privacy'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'chihuahua',
    client_id: '07-tendermint-86',
    connection_id: 'connection-55'
  },
  chain_2: {
    chain_name: 'stafihub',
    client_id: '07-tendermint-2',
    connection_id: 'connection-2'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-25',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;